import { get } from '@/lib/request/webapp/http';

export default function userHasPermission(permissionKey = '') {
  return (window?.$dt?.objConfig.Me?.Permissions || []).includes(permissionKey);
}

export async function loadUserPermissions() {
  if (!window.$dt?.objConfig.Me) {
    const { data } = await get(`api/v1/me`);

    window.$dt = window.$dt || {};
    window.$dt.objConfig = window.$dt.objConfig || {};
    window.$dt.objConfig.Me = data;
  }
}
